module.exports = __webpack_public_path__ + "static/material-fleece.c4c04db7.svg";